import type { Product } from '@/types';
import { Container } from '@/components/atoms';
import { FaqAccordionItem } from '@/components/molecules';

export function PdpFaq({ product }: { product: Product }) {
  if (!product.faqItems.length) return null;
  return (
    <Container className="py-12">
      <h2 className="mb-4 font-condensed text-2xl font-bold text-night-blue">Frequently asked</h2>
      <div className="mx-auto max-w-2xl">
        {product.faqItems.map((f, i) => (
          <FaqAccordionItem key={i} question={f.question} answer={f.answer} defaultOpen={i === 0} />
        ))}
      </div>
    </Container>
  );
}
